//axios configuration
import Axios from 'axios'
const instance  =  Axios.create({
baseURL: (process.env.NODE_ENV === 'production') ? 'https://lastmileallocationpod-api.xbees.in/' : 'https://lastmileallocationpod-apistage.xbees.in/',
responseType: 'json',
timeout: 20000
})
const axiosinstance = instance;
export { axiosinstance }



//////////////////
// WEBPACK FOOTER
// ./services/axiosins.js
// module id = 1131
// module chunks = 1